// Common app files.
// Pages are lazy-loaded using angular-router-loaded.

import '../main'
import '../app/app.module'
import '../app/common'
import '../app/core'
import '../app/decorators'
import '../app/models'
import '../app/serializers'
import '../app/util'



// WEBPACK FOOTER //
// ./~/angular2-template-loader!./~/angular-router-loader/src!./bundles/app-common.ts